<template>
    <div class="question-selector">
        <div class="cursor-pointer" @click="toggleOpened">
            <h3>
                <span :class="getIconClass" aria-hidden="true"></span>
                <slot></slot>
                {{ title }}
                <template v-if="selected.length > 0">
                    <div class="badge badge-primary" style="transform: translateY(-30%);">{{ selected.length }}</div>
                </template>
            </h3>
        </div>
        <div class="questions" :class="{ hidden: !opened }">
            <div v-for="(question, index) in questions" class="question-selector__question" :key="index" :class="{dimmed:!question.enabled}">
                <div class="s-2-lpad">
                    <p>
                        <label class="cursor-pointer">
                            <input type="checkbox" v-model="selected" :value="question.key" :disabled="!question.enabled" :id="getQId(index)" />
                            <strong>Q.&thinsp;{{ question.number }}&nbsp;:</strong>
                        </label>
                    </p>
                </div>
                <div>
                    <template v-if="!isEmpty(question.title)">
                        <label :for="getQId(index)" v-html="question.title"></label>
                    </template>
                    <template v-if="!isEmpty(question.subtitle)">
                        <label :for="getQId(index)" v-html="question.subtitle"></label>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    name: 'question-selector',
    props: {
        sectionNumber: {
            type: [Number, String],
        },
        title: String,
        questions: Array,
    },

    data: () => ({
        opened: false,
        selected: [],
        isEmpty,
    }),

    watch: {
        selected ()
        {
            this.$store.dispatch('SET_SELECTED_ANSWERS_FOR_SECTION', [
                this.sectionNumber,
                this.selected,
            ]);
        },
    },

    computed: {
        getIconClass ()
        {
            const out = ['glyphicon']
            if (this.opened)
            {
                out.push('glyphicon-chevron-down')
            }
            else
            {
                out.push('glyphicon-chevron-right')
            }
            return out
        },
    },

    methods: {
        toggleOpened ()
        {
            this.opened = !this.opened
        },

        getQId (num)
        {
            return `S${this.sectionNumber}-i${num}`
        },
    },

}
</script>

<style scoped>
    .dimmed {
        pointer-events: none;
        opacity: 0.5;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-selector.vue